exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active-subscription-col:last-child .active-subscription[data-v-91fa769c]{border-bottom:1px solid #D6D8DE}.active-subscription[data-v-91fa769c]{padding:10px 0;border-top:1px solid #D6D8DE;margin:0;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box;cursor:pointer;font-size:0.9em}@media (max-width: 767px){.active-subscription div[data-v-91fa769c]{margin:5px 0}}.auto-width[data-v-91fa769c]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}\n", ""]);

// exports
